/* eslint-disable @typescript-eslint/no-explicit-any */
// @ts-nocheck
/**
 * VisualKey — companion legend strip to TierLegend that teaches users
 * how to read the new at-a-glance indicators (tier pills, delta chips,
 * bar meters, rank badges). Drop it right below TierLegend on any view
 * that uses those indicators so users have one pinned reference card.
 *
 * Default layout is a single horizontal strip; `compact` shrinks it for
 * tight sidebars.
 */
import React from 'react';
import { TierPill } from './TierPill';
import { DeltaChip } from './DeltaChip';
import { BarMeter } from './BarMeter';
import { RankBadge } from './RankBadge';

type Props = {
  compact?: boolean;
  className?: string;
};

const ITEMS: Array<{ label: string; help: string; node: React.ReactNode }> = [
  {
    label: 'Tier Pill',
    help: 'Score → tier at a glance. Color + label.',
    node: <TierPill score={78} noTooltip />,
  },
  {
    label: 'vs Baseline',
    help: 'How this value compares to the county / parent / peer median.',
    node: (
      <DeltaChip
        value={62}
        baselines={[
          { label: 'vs county', value: 48 },
          { label: 'vs LD', value: 55 },
        ]}
        format="num"
      />
    ),
  },
  {
    label: 'Bar Meter',
    help: 'Fill shows value as % of 100. Tick = baseline.',
    node: (
      <div className="w-24">
        <BarMeter value={62} baseline={48} showValue />
      </div>
    ),
  },
  {
    label: 'Rank',
    help: 'Where this entity stands in its peer group.',
    node: <RankBadge rank={3} total={16} />,
  },
];

export const VisualKey: React.FC<Props> = ({
  compact = false,
  className = '',
}) => {
  return (
    <div
      className={`flex items-center gap-3 flex-wrap rounded-lg border border-border-base bg-bg-raised/60 px-3 py-2 ${className}`}
    >
      <span className="text-[10px] uppercase tracking-wide text-fg-muted font-semibold mr-1">
        How to read it
      </span>
      {ITEMS.map((item) => (
        <span
          key={item.label}
          className="inline-flex items-center gap-1.5"
          title={item.help}
        >
          {item.node}
          {!compact && (
            <span className="text-[10px] text-fg-muted">{item.label}</span>
          )}
        </span>
      ))}
    </div>
  );
};

export default VisualKey;
